// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"21b7cbf0","93":"1a6b7101","101":"131f19a7","251":"e3cb0f42","282":"21b7cbf0","787":"8f3d61b2","837":"131f19a7"}[chunkId] + ".chunk.css";
};